// extracted by mini-css-extract-plugin
export var container = "index-module--container--3nAfL";
export var wrap = "index-module--wrap--SSOwZ";
export var indexshop = "index-module--indexshop--pkFx8";
export var img = "index-module--img--2aPnS";